export default __webpack_public_path__ + "static/media/Logo.39af16d0.png";